import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';

import {
  CreateContactFromFilePatternDto,
  CreateContactsFromFileCommand,
  CustomField,
  GenderType,
} from 'src/app/core/api/models';
import { ContactsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { GetPhonebooksWithPaginationDto } from 'src/app/core/models/phonebook-tree.model';
import { AuthTokenService } from 'src/app/core/services/authentication/auth-token.service';
import { AppConfigService } from 'src/app/core/services/config.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { FileService } from 'src/app/core/services/file.service';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { DeleteContactByCellPhoneComponent } from '../delete-contact-by-cellphone/delete-contact-by-cellphone.component';

@Component({
    selector: 'app-contacts-import-from-xlsx',
    templateUrl: './contacts-import-from-xlsx.component.html',
    styleUrls: ['./contacts-import-from-xlsx.component.scss'],
    imports: [BaseFormModule, DeleteContactByCellPhoneComponent]
})
export class ContactsImportFromXlsxComponent
  extends BaseFormPageComponent
  implements OnInit
{
  translate = inject(TranslateService);

  pageVocabs = 'pages.contacts.form.';
  file: File;
  model: CreateContactsFromFileCommand = {};
  //this field generated when file changed
  jsonData: Array<Object> = null;
  //list of column's in imported excel file
  finalImportedColList: { value: string; key: string }[] = [];
  importedColList: string[] = [];
  //total Item's in The Imported file
  totalEntry = 0;

  @Input() phonebookTitle: string;
  cellPhoneFieldName: string = '';
  addressFieldName: string = '';
  emailFieldName: string = '';
  firstNameFieldName: string = '';
  genderFieldName: string = '';
  jobFieldName: string = '';
  lastNameFieldName: string = '';
  telephoneFieldName: string = '';
  customFieldsMap = {};
  isDisabledSubmit: boolean = false;
  //Vocabs = 'pages.contacts.importfromfile';

  apiModel: any;
  previewModel: any;
  deletePhonebookIdsModel: Array<number> = [];

  @Input() selectedPhonebook: GetPhonebooksWithPaginationDto;
  @Input('customFields') input_customFields: CustomField[] = [];
  progress: number;
  action: string =
    AppConfigService.config.apiUrl + '/Contacts/UploadContactsFile';
  filePath: string = '';
  pattern: CreateContactFromFilePatternDto[] = [];
  apiUrl: string = AppConfigService.config.apiUrl;

  constructor(
    public http: HttpClient,
    private contactService: ContactsService,

    protected fileService: FileService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.getVocabs();
    this.initForm();
    this.fields = 'pages.contacts.importfromfile.fields.';
  }

  initForm() {
    this.form = new FormGroup({
      phonebook: new FormControl(this.phonebookTitle),
      inputFile: new FormControl(),
      mobileFieldName: new FormControl('', Validators.required),
      phonebookIds: new FormControl(),
    });
    try {
      this.form.controls['phonebook'].disable();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  baseCreateApi(model: any): void {
    //this.contactService.contactsCreateContactsFromList({})
  }

  createOrUpdateCustomFieldMap(fieldName: string, jsonFieldName: any) {
    try {
      ConsoleService.info('jsonFieldName', jsonFieldName);
      this.customFieldsMap[fieldName] = jsonFieldName;
      ConsoleService.info('customFieldsMap', this.customFieldsMap);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  async readFileAndCreateInMemoryData(file: File) {
    try {
      this.previewModel = null;
      this.importedColList = [];

      this.loading = true;

      if (file == null || file == undefined) {
        this.jsonData = null;
        this.loading = false;
        this.totalEntry = 0;
        this.importedColList = [];
        return;
      }

      this.progress = 1;
      let formData: any = new FormData();
      let fileToUpload = <File>file;

      formData.append(
        'file',
        fileToUpload,
        fileToUpload.name.replace(/\s/g, '')
      );

      const headers = new HttpHeaders()
        .set('Accept', 'application/json')
        .set('enctype', 'multipart/form-data')
        .set('ngsw-bypass', 'true')
        .set('Authorization', 'Bearer ' + AuthTokenService.getAccessToken());

      this.http
        .post(this.action, formData, {
          headers: headers,
          reportProgress: true,
          observe: 'events',
        })
        .pipe(
          this.basePipeOperators(),
          tap((event: any) => {
            if (event.type == HttpEventType.UploadProgress) {
              this.progress = Math.round((100 / event.total) * event.loaded);
            } else if (event.type == HttpEventType.Response) {
              this.progress = null;
            }
          })
        )
        .subscribe((result) => {
          if (result.body) {
            result = result.body;
            this.apiNotificationService.notifyMessage({ result });
            if (result.isSucceed) {
              let data = JSON.parse(result?.data);
              this.filePath = data.path;

              this.importedColList = [];
              this.jsonData = null;
              this.model.patterns = [];
              this.totalEntry = 0;
              this.loading = false;
              this.importedColList = data.data[0];
              this.finalImportedColList = data.data[0].map((str) => ({
                key: str,
                value: str,
              }));

              this.finalImportedColList.unshift({
                key: '',
                value: this.translate.instant(this.fields + 'empty'),
              });
              this.jsonData = data.data;
              this.totalEntry = this.jsonData.length;
              this.getPreviewModel();
            }
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getPreviewModel() {
    try {
      this.previewModel = [];
      for (let index = 1; index < this.jsonData.length; index++) {
        this.previewModel.push(Object.values(this.jsonData[index]));
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  async onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.jsonData == null) {
        return;
      }
      this.loading = true;
      await this.makeApiInputViewModel();
      let data = JSON.stringify(this.apiModel);
      // this.loading = true;
      this.cd.detectChanges();
      data = this.compressionString(data);
      if (this.deletePhonebookIdsModel?.length > 0) {
        this.model.deleteContactsFromPhonebooksByCellPhoneInput = {};
        this.model.deleteContactsFromPhonebooksByCellPhoneInput.phonebookIds =
          this.deletePhonebookIdsModel;
      } else
        this.model.deleteContactsFromPhonebooksByCellPhoneInput = undefined;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }

    this.filePath = this.apiUrl + '/' + this.filePath;

    this.contactService
      .contactsCreateContactsFromFilePost({
        body: {
          filePath: this.filePath,
          phonebookId: this.selectedPhonebook.id,
          patterns: this.pattern,
          // jsonModel: data,
          deleteContactsFromPhonebooksByCellPhoneInput:
            this.model.deleteContactsFromPhonebooksByCellPhoneInput,
        },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  getPattern(contactColumn, excelColumn) {
    try {
      let pattern: CreateContactFromFilePatternDto = {};
      pattern.contactColumn = contactColumn;
      pattern.excelColumn = excelColumn;

      this.pattern.forEach((element, index) => {
        if (element.contactColumn == contactColumn)
          this.pattern.splice(index, 1);
      });

      this.pattern.push(pattern);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  async makeApiInputViewModel() {
    try {
      this.apiModel = {
        phonebookId: this.selectedPhonebook.id,
        contacts: [],
      };
      let customFieldKey = Object.keys(this.customFieldsMap);
      //now most create contact's one by one and add to the model
      for (let index = 0; index < this.jsonData.length; index++) {
        let contact = this.getModel(customFieldKey, index);
        this.apiModel.contacts.push(contact);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getModel(customFieldKey, index) {
    try {
      let contact: ContactInList = {
        customFields: [],
      };
      //#region map contact
      if (this.cellPhoneFieldName.length > 0) {
        contact.cellPhone = this.jsonData[index][this.cellPhoneFieldName];
      }
      if (this.addressFieldName.length > 0) {
        contact.address = this.jsonData[index][this.addressFieldName];
      }
      if (this.emailFieldName.length > 0) {
        contact.email = this.jsonData[index][this.emailFieldName];
      }
      if (this.firstNameFieldName.length > 0) {
        contact.firstName = this.jsonData[index][this.firstNameFieldName];
      }
      if (this.genderFieldName.length > 0) {
        contact.gender = this.jsonData[index][this.genderFieldName];
      }
      if (this.jobFieldName.length > 0) {
        contact.job = this.jsonData[index][this.jobFieldName];
      }
      if (this.lastNameFieldName.length > 0) {
        contact.lastName = this.jsonData[index][this.lastNameFieldName];
      }
      if (this.telephoneFieldName.length > 0) {
        contact.telephone = this.jsonData[index][this.telephoneFieldName];
      }
      //now most generate custom field's
      customFieldKey.forEach((item) => {
        var customfld: CustomField = null;
        for (let tmpi = 0; tmpi < this.input_customFields.length; tmpi++) {
          if (this.input_customFields[tmpi].nameEn == item) {
            customfld = this.input_customFields[tmpi];
          }
        }
        if (customfld != null) {
          let cf: CustomField = {
            nameEn: customfld.nameEn,
            nameFa: customfld.nameFa,
            value: this.jsonData[index][this.customFieldsMap[item]],
            fieldType: customfld.fieldType,
          };
          contact.customFields.push(cf);
        }
      });
      //#endregion
      return contact;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
}

export class ContactInList {
  firstName?: string;
  lastName?: string;
  telephone?: string;
  cellPhone?: string;
  gender?: GenderType;
  email?: string;
  job?: string;
  address?: string;
  customFields?: CustomField[];
}
